import { TalkButton } from "./TalkButton.js";
import { CombatTracker } from "./Combat.js";
import { DiceTray, RollLog } from "./Dice.js";
import { PartyPanel } from "./Party.js";

/** The web table: dice + roll log on the left, party + initiative tracker on the right. */
export function TablePage() {
  return (
    <main className="table-grid">
      <div className="col">
        <TalkButton />
        <DiceTray />
        <RollLog />
      </div>
      <div className="col">
        <PartyPanel />
        <CombatTracker />
      </div>
    </main>
  );
}
